import { createFileRoute } from '@tanstack/react-router'
import AdminActivityLogPage from '@/pages/admin/activity-log'

export const Route = createFileRoute('/app/admin/activity-log')({
  component: RouteComponent,
})

function RouteComponent() {
  return <AdminActivityLogPage />
}
